import { ProviderFeatures } from './provider-features';

export const nxtWashFeatures: ProviderFeatures = {
  actions: {
    cancel: {
      enabled: true,
      schedules: {
        immediate: true,
        'end-of-period': false,
      },
      unpauseOnCancel: false,
    },
    pause: {
      enabled: false,
      extendPeriodEnd: false,
      startDates: {
        'period-end': true,
        immediate: true,
      },
      durations: {
        period: true,
        date: false,
      },
    },
    changePrice: {
      enabled: false,
      schedules: {
        immediate: true,
        'end-of-period': false,
      },
      prorate: true,
    },
    applyCoupon: {
      enabled: false,
    },
    extendTrial: {
      enabled: false,
    },
  },
  controllers: {
    coupons: {
      enabled: false,
      create: false,
      import: false,
    },
    customers: {
      findByEmail: false,
    },
  },
  features: {
    metricsDashboard: false,
    customerProfile: false,
  },
};
